/**
 * Apple 3.1.1 guard. The native app never shows a price, a buy button,
 * or a link to a purchase page. CommonJS only. No object spread.
 */

const NATIVE_INACTIVE_PLAN_MESSAGE = "Your plan isn't active.";

function uncoveredPlanLead(annualEnabled) {
  const price = annualEnabled ? '$4.99/month or $49/year' : '$4.99/month';
  return `Your sponsor isn't covering Pacarion right now. You can still keep everything in one place with the Homeowner plan, ${price}, on pacarion.com.`;
}

function isNativePlatform(isNative) {
  return isNative === true;
}

function purchaseUiAllowed(isNative) {
  return !isNativePlatform(isNative);
}

function inactivePlanCopy(isNative) {
  if (isNativePlatform(isNative)) {
    return {
      native: true,
      message: NATIVE_INACTIVE_PLAN_MESSAGE,
      showPrice: false,
      showCheckout: false,
      showPortal: false,
      showPurchaseLink: false,
    };
  }
  return {
    native: false,
    message: '',
    showPrice: true,
    showCheckout: true,
    showPortal: true,
    showPurchaseLink: true,
  };
}

function nativeCopyHasPurchaseCue(text) {
  const value = String(text || '');
  if (/\$\s*\d/.test(value)) return true;
  if (/https?:\/\//i.test(value)) return true;
  if (/\b(buy|subscribe|checkout)\b/i.test(value)) return true;
  if (/<a\b/i.test(value)) return true;
  return false;
}

module.exports = {
  NATIVE_INACTIVE_PLAN_MESSAGE,
  uncoveredPlanLead,
  isNativePlatform,
  purchaseUiAllowed,
  inactivePlanCopy,
  nativeCopyHasPurchaseCue,
};
